module.exports = __webpack_public_path__ + "static/client-profile-icon-d48b14dc453cf8a5f12119242e45ae51.jpg";